/* eslint-disable camelcase */
import React, { memo, useEffect, useCallback, useRef, useState } from 'react';
import { toast } from 'react-toastify';

import { isEmpty, isArray, isNull } from 'lodash';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { Input, Autocomplete, Hidden } from '~/components/Form';
import { t } from '~/helpers';
import { validation, validationErrors } from '~/helpers/yupValidations';
import api from '~/services/api';

import { MeterTable } from '..';

import * as S from './styles';

function FormRevenues({
  data,
  components,
  visible,
  sending,
  close,
  onForm,
  ehCarregamento,
}) {
  const formRef = useRef(null);

  const [composition, setComposition] = useState([]);
  const [meters, setMeters] = useState([]); // useState(data.medidores || []);

  // Format number to American standard with only one decimal place
  const formatNumberDecimal = useCallback((number) => {
    const value = String(number).split('.');
    const decimal = value.length > 1 ? value[1].substr(0, 1) : '0';

    return `${value[0]}.${decimal}`;
  }, []);

  const handleSearchComponents = useCallback(
    async ({ idproduto, nomeabreviadoproduto }) => {
      const composicao = [
        {
          idproduto,
          nomeabreviadoproduto,
        },
      ];
      setComposition(composicao);
      // try {
      //   if (isNull(idproduto)) setComposition([]);
      //   else {
      //     const option = await api.get(`produtos/${idproduto}`, {
      //       params: { pesquisalista: true },
      //     });
      //     console.log('x');
      //     console.log(option.data.composicao);
      //     console.log(option.data);
      //     setComposition(option.data);
      //   }
      // } catch (error) {
      //   if (isArray(error)) error.map((err) => toast.error(t(err)));
      //   else toast.error(t(error));

      //   setComposition([]);
      // }
    },
    [components]
  );

  // Submit form data
  const handleSubmit = useCallback(
    async (values) => {
      try {
        const minPPM = t('labelsistema.erro_numero_minimo').replace('%s', 0);
        const maxPPM = t('labelsistema.erro_numero_maximo').replace(
          '%s',
          999999
        );

        const schema = Yup.object().shape({
          idpresetreceita: Yup.number()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .min(1, t('s.geral.validacao.valorminimo').replace('%s', 1))
            .max(99, t('s.geral.validacao.valormaximo').replace('%s', 99)),
          idproduto: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio')),
          nomepresetreceita: Yup.string()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(10, t('s.geral.validacao.valormaximo').replace('%s', 10)),
        });

        await validation(schema, values);

        if (composition.length !== meters.length)
          throw t('labelsistema.error_selecionar_medidores');

        const formData = {
          id: Math.random().toString(),
          ...data,
          ...values,
          medidor: meters[0],
          nomeproduto: values.nomeproduto || data.nomeproduto,
        };

        await onForm(formData);
        await close();
      } catch (error) {
        validationErrors(error, formRef);
      }
    },
    [data, meters, composition]
  );

  const handleChangeMeters = useCallback((values) => {
    setMeters(values.map((item) => Number(item.value)));
  }, []);

  useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);

  useEffect(() => {
    const m = [];
    if (data && data.medidor) {
      m[0] = data.medidor;
    }
    setMeters(m);
  }, [data]);

  // Check if the item is visible
  if (!visible) return <div />;

  return (
    <S.Wrapper ref={formRef} initialData={data} onSubmit={handleSubmit}>
      <Input
        name="idpresetreceita"
        type="number"
        label={t('s.cadastro.presetreceita.idpresetreceita')}
        disabled={!isEmpty(data)}
      />
      <Autocomplete
        name="idproduto"
        url="/produtos"
        label="nomeabreviadoproduto"
        unique="idproduto"
        title={t('s.menu.configuracao.produto')}
        disabled={!isEmpty(data)}
        hiddens={[{ name: 'nomeabreviadoproduto' }]}
        getValue={handleSearchComponents}
      />
      <MeterTable
        composition={composition}
        meters={components}
        onCallback={handleChangeMeters}
        initials={
          isEmpty(data)
            ? []
            : () => {
                const component = components.find(
                  (comp) =>
                    Number(comp.medidorpresetproduto) === Number(data.medidor)
                );

                return {
                  component: component ? component.idproduto : null,
                  value: data.medidor.toString(),
                };
              }
          // : data.medidor.map((med) => {
          //     const component = components.find(
          //       (comp) => Number(comp.medidor) === Number(med)
          //     );

          //     return {
          //       component: component ? component.idproduto : null,
          //       value: med.toString(),
          //     };
          //   })
        }
      />
      <Input
        name="nomepresetreceita"
        label={t('s.configuracao.produto.nomeproduto')}
        disabled={!isEmpty(data)}
      />
    </S.Wrapper>
  );
}

FormRevenues.propTypes = {
  data: PropTypes.objectOf(PropTypes.any),
  components: PropTypes.arrayOf(PropTypes.any).isRequired,
  close: PropTypes.func.isRequired,
  onForm: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  ehCarregamento: PropTypes.bool.isRequired,
};

FormRevenues.defaultProps = {
  data: {},
};

export default memo(FormRevenues);
